"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextLegal = void 0;
var _createText = require("./createText");
const TextLegal = (0, _createText.createText)('legal');
exports.TextLegal = TextLegal;